module.exports = __webpack_public_path__ + "img/icn_circle.d0146e52.svg";